import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('login.twoFactor.BackupCode');
export default {
  type: 'backup-code',
  get name() {
    return t('name');
  },
  get description() {
    return t('description');
  },
  get submitInstruction() {
    return t('submitInstruction');
  },
  sort: 'zzz',
  isClientSide: true,
  isUniversal: true,
  canBeActivated: false
};